<template>
  <section class="start-layout" @click="$emit('click')">
    <div v-if="icon" class="start-layout__icon">
      <icon :src="icon"></icon>
    </div>
    <div class="start-layout__content">
      <p class="start-layout__main-content">
        {{ content }}
      </p>
      <p class="start-layout__sub-content">
        {{ subContent }}
      </p>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/ui/Icon';

export default {
  name: 'StartLayout',
  components: {
    Icon
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    subContent: {
      type: String,
      default: ''
    },
    icon: {
      type: String
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.start-layout {
  display: flex;
  align-items: center;
  font-size: sizeTrans(14);
  line-height: sizeTrans(24);

  &__content {
    flex: 1;
  }

  &__main-content {
    @include blue_sky_bold;
  }

  &__icon {
    width: sizeTrans(24);
    min-width: sizeTrans(24);
    height: sizeTrans(24);
    margin-right: sizeTrans(15);
  }
}
</style>